import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { RatingsProvider } from '../../providers/ratings/ratings';

import { IRating } from '../../interfaces/ratings';


@Component({
  selector: 'rating-for-stafftype',
  templateUrl: 'rating-for-stafftype.html'
})
export class RatingForStaffTypeComponent implements OnInit, OnDestroy {
  @Input() staffType: string;
  @Input() uid: string;
  ratings: IRating[] = [];
  ratingsSubscription: Subscription;
  ratingsDataLoaded = false;
  ratingAverage = 0;

  constructor(private ratingsProvider: RatingsProvider) {}

  ngOnInit() {
    console.log(`rating-for-stafftype: ${this.staffType} for user: ${this.uid}`);
    this.ratingsSubscription = this.ratingsProvider.getUserRatingsByStaffType(this.uid, this.staffType).subscribe(
      data => {
        console.log(data);

        let total = 0;
        if (data) {
          total = data.length * 5;
        }
        console.log(`total: ${total}`);
        
        let score = 0;
        data.forEach(r => {
          score = score + r.rating;
        });
        console.log(`score: ${score}`);
        
        console.log(`raw average: ${(score / total) * 5}`);
        this.ratingAverage = Math.round((score / total) * 5);
        console.log(`rounded average: ${this.ratingAverage}`);

        this.ratingsDataLoaded = true;

        return data;
      },
      err => {
        console.log(err);
      }
    );
    
  }

  ngOnDestroy() {
    if (this.ratingsSubscription) {
      this.ratingsSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/rating/rating-for-stafftype.ts